/** @format */
import React, { useEffect, useRef, useState } from "react";
import { styled, useTheme } from '@mui/material/styles';
import { Box, Toolbar, Typography, Divider, Button } from '@mui/material';
import { useOutletContext } from "react-router-dom";
import * as pdfjs from "pdfjs-dist";
import workerSrc from "pdfjs-dist/build/pdf.worker?url";
import { apiEndpoint } from "../../urls";
import MuiAppBar from '@mui/material/AppBar';
import Loader from "../Loader";

pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;

const PdfPreview = ({ previewDoc, setPreviewDoc, previewDocument, setPreviewDocument }) => {
  const { open } = useOutletContext();
  const [numPages, setNumPages] = useState(null);
  const [pdf, setPdf] = useState(null);
  const canvasRefs = useRef([]);  
  const thumbnailRefs = useRef([]);
  const [activePage, setActivePage] = useState(0);
  const viewerRef = useRef(null);
  const [loader, setLoader] = useState(false);
  
  useEffect(() => {
    const loadPdf = async () => {
      if (!previewDoc) return;
      setLoader(true)
      const loadingTask = pdfjs.getDocument(previewDoc?.document_url);
      const pdfDoc = await loadingTask.promise;
      setNumPages(pdfDoc.numPages);
      setPdf(pdfDoc);
    };

    loadPdf();
  }, [previewDoc]);

  useEffect(() => {
    if (!pdf) return;

    const renderPages = async () => {
      for (let i = 1; i <= numPages; i++) {
        const page = await pdf.getPage(i);
        const viewport = page.getViewport({ scale: 1.5 });

        const canvas = canvasRefs.current[i - 1];
        if (!canvas) continue;

        const context = canvas.getContext("2d");
        context.clearRect(0, 0, canvas.width, canvas.height);
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        const renderContext = { canvasContext: context, viewport };
        page.render(renderContext);
      }
      setLoader(false);
    };

    renderPages();
  }, [pdf, numPages]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = Number(entry.target.dataset.index);
            setActivePage(index);
  
            // Scroll thumbnail into view
            const thumb = thumbnailRefs.current[index];
            if (thumb) {
              thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
            }
          }
        });
      },
      { root: viewerRef.current, rootMargin: "0px", threshold: 0.6 }
    );
  
    canvasRefs.current.forEach((canvas, index) => {
      if (canvas) {
        canvas.dataset.index = index;
        observer.observe(canvas);
      }
    });
  
    return () => {
      observer.disconnect();
    };
  }, [numPages]);

  const handleThumbnailClick = (index) => {
    const pageCanvas = canvasRefs.current[index];
    if (pageCanvas) {
      pageCanvas.scrollIntoView({ behavior: "smooth", block: "start" });
      setActivePage(index);
    }
  };

  const handleScroll = () => {
    let minDiff = Infinity;
    let currentIndex = 0;

    canvasRefs.current.forEach((canvas, index) => {
      if (canvas) {
        const rect = canvas.getBoundingClientRect();
        const diff = Math.abs(rect.top);

        if (diff < minDiff) {
          minDiff = diff;
          currentIndex = index;
        }
      }
    });

    setActivePage(currentIndex);
  };

  const handlePreviewBack = () => {
    setPreviewDoc({});
    setPreviewDocument(!previewDocument);
  }

  const drawerWidth = 240;

  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: open ? drawerWidth : 100,
    // width: open ? `calc(100% - ${drawerWidth}px)` : `calc(100% - 65px)`,
    width: '100%',
    height: '80px'
  }));


  const handleDownload = async (doc) => {
    console.log('doccccccc',doc)
    if(doc?.document_url)
    { 
      setLoader(true);
      let URLdata = doc?.document_url;
      var responsefile = await fetch(URLdata);
      if (!responsefile.ok) {
        setLoader(false);
        throw new Error(`Failed to fetch file: ${responsefile.statusText}`);
      }

      const blob = await responsefile.blob();
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = doc?.document_name;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      setLoader(false);
    }
  };

  return (<>
    <Box
      sx={{
        flexGrow: 1,
        width: "100%",
        transition: "margin 0.3s ease",
        height: "calc(100% - 0px)",
        display: "flex",
        position: "absolute",
        top: 0,
        left: 0,
        p: 2,
        background: "#f4f4f4",
        zIndex: 9999,
        
      }}
    >
      <AppBar position="fixed" open={open} sx={{ background: "#fff", color: "#000", boxShadow: "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgb(209, 213, 219) 0px 0px 0px 0px inset" }}>
        <Toolbar sx={{ height: "80px", display: "flex", justifyContent: "space-between", }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: 1, alignItems: 'center', width: "100%" }}>
              <Box sx={{ display: "flex", cursor: "pointer" }} onClick={handlePreviewBack} >
                <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18L2 10L9 2" stroke="#2556AB" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <Typography noWrap component="p" sx={{ fontSize: '20px', fontWeight: 600, lineHeight: '20px', color: "#1D1D1D", ml: 2 }}>
                    {previewDoc?.document_name}
                </Typography>
              </Box>
              <Box>
                <Button variant="contained" sx={{ width: '142px', height: 40, color: "#1D1D1D", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #E4E4E4", boxShadow: "none", fontWeight: "500", position: "relative", "&:disabled": {background: "#ffffff", color: "#8DB0E2", borderColor: "#8DB0E2"}, }} onClick={() => handleDownload(previewDoc)} >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 14L3.23384 14.6626C4.144 17.2413 4.59908 18.5307 5.63742 19.2654C6.67576 20 8.0431 20 10.7778 20H13.2222C15.9569 20 17.3242 20 18.3626 19.2654C19.4009 18.5307 19.856 17.2413 20.7662 14.6626L21 14" stroke="#1C5DBC" stroke-width="2" stroke-linecap="round"/>
                  <path d="M12 14V4M12 14C11.2998 14 9.99153 12.0057 9.5 11.5M12 14C12.7002 14 14.0085 12.0057 14.5 11.5" stroke="#1C5DBC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Download
                </Button>
              </Box>
            </Box>
        </Toolbar>
      </AppBar>
      <Box sx={{ display: "flex", width: "100%", height: "calc(100% - 83px)", marginTop: "87px", borderRadius: "12px", p: "8px", background: "#FFFFFF" }}>
        <Box
          sx={{
            width: "200px",
            height: "100%",
            overflowY: "auto",
            overflowX: "hidden",
            background: "#fff",
            p: 1,
          }}
        >
          {Array.from({ length: numPages }, (_, index) => (
            <Box
              key={index}
              sx={{
                position: "relative",
                overflow: "hidden",
              }}
              ref={(el) => (thumbnailRefs.current[index] = el)}
              onClick={() => handleThumbnailClick(index)}
            >
              <canvas
                key={index}
                style={{
                  width: "176px",
                  height: "207px",
                  marginBottom: "8px",
                  cursor: "pointer",
                  border: activePage === index ? "3px solid #185CB7" : "2px solid #D9D9D9",
                  borderRadius: 12,
                }}
                ref={(el) => {
                  if (!el || !pdf) return;
                  thumbnailRefs.current[index] = el
                  pdf.getPage(index + 1).then((page) => {
                    const scale = 0.3;
                    const viewport = page.getViewport({ scale });

                    el.width = viewport.width;
                    el.height = viewport.height;

                    const context = el.getContext("2d");
                    page.render({ canvasContext: context, viewport });
                  });
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: "15px",
                  left: 0,
                  background: "rgba(0, 0, 0, 0.6)",
                  color: "#fff",
                  width: "176px",
                  height: "30px",
                  alignContent: "center",
                  textAlign: "center",
                  borderBottomLeftRadius: "12px",
                  borderBottomRightRadius: "12px",
                }}
              >
                {index + 1}
              </Box>
            </Box>
          ))}
        </Box>
        <Box
          sx={{
            flexGrow: 1,
            textAlign: "center",
            background: "#fff",
            width: "75%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            overflowY: "auto",
            p: 2,
          }}
          onScroll={handleScroll}
        >
          {Array.from({ length: numPages }, (_, index) => (
            <canvas
              key={index}
              ref={(el) => (canvasRefs.current[index] = el)}
              style={{ marginBottom: "20px", border: "1px solid #ddd", scrollMarginTop: "10px", }}
            />
          ))}
        </Box>
      </Box>
    </Box>
    {loader && <Loader />}
    </>
  );
};

export default PdfPreview;
